import Vue from 'vue'
// import store from '../store'

export const Login = function (email, pass) {
    var formData = new FormData()
    formData.append('usuario', email)
    formData.append('pass', pass)
    return Vue.http.post('login.php', formData)
        .then((response) => {
            //  errors
            if (response.body.errors) {
                return response.body
            }

            return response.body
        })
}

const getArticules = function(id) {
    return Vue.http.get('blog.php?blog=' + id)
        .then((response) => {
            if (response.body.errors) {
                return response.body
            }
            return response.body
        })
}

const getBlogInfo = function(id) {
    return Vue.http.get('blog_info.php?blog=' + id)
        .then((response) => {
            if (response.body.errors) {
                return response.body
            }
            return response.body
        })
}

export const createArticulo = function (titulo, subtitulo, escritor, web, portada, imgEscritor, link, items) {
    var formData = new FormData()
    formData.append('titulo', titulo)
    formData.append('subtitulo', subtitulo)
    formData.append('escritor', escritor)
    formData.append('web', web)
    formData.append('portada', portada)
    formData.append('link', link)
    formData.append('img_escritor', imgEscritor)
    var contTexto = 0
    var contVideo = 0
    var contImagen = 0
    var order = []
    items.forEach(element => {
        if (element.type === 'video') {
            formData.append('video[]', element.info)
            contVideo++
        }
        if (element.type === 'texto') {
            formData.append('texto[]', element.info)
            contTexto++
        }
        if (element.type === 'imagen') {
            formData.append('file[]', element.info)
            contImagen++
        }
        order.push(element.type)
        formData.append('contadores', JSON.stringify({video: contVideo, imagen: contImagen, texto: contTexto}))
        formData.append('order', JSON.stringify(order))
    })
    return Vue.http.post('create_articule.php', formData, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
        .then((response) => {
            if (response.body.errors) {
                throw response.body.errors
            }
            return response.body
        })
}

export const updateBlog = function (titulo, subtitulo, escritor, web, portada, imgEscritor, link, items, id) {
    var formData = new FormData()
    formData.append('titulo', titulo)
    formData.append('subtitulo', subtitulo)
    formData.append('escritor', escritor)
    formData.append('web', web)
    formData.append('link', link)
    formData.append('portada', portada)
    formData.append('img_escritor', imgEscritor)
    var contTexto = 0
    var contVideo = 0
    var contImagen = 0
    var order = []
    items.forEach(element => {
        if (element.type === 'video') {
            formData.append('video[]', element.info)
            contVideo++
        }
        if (element.type === 'texto') {
            formData.append('texto[]', element.info)
            contTexto++
        }
        if (element.type === 'imagen') {
            formData.append('file[]', element.info)
            contImagen++
        }
        order.push(element.type)
        formData.append('contadores', JSON.stringify({video: contVideo, imagen: contImagen, texto: contTexto}))
        formData.append('order', JSON.stringify(order))
    })
    return Vue.http.post('update_blog.php?blog_id=' + id, formData, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
        .then((response) => {
            if (response.body.errors) {
                throw response.body.errors
            }
            return response.body
        })
}

export const getArticulesList = function(limit, offset, web = 1) {
    return Vue.http.get('get_articules.php?limit=' + limit + '&offset=' + offset + '&web=' + web)
        .then((response) => {
            if (response.body.errors) {
                throw response.body.errors
            }
            return response.body
        })
}

export const deleteArticulo = function (id) {
    return Vue.http.delete('delete_articule.php?articule_id=' + id)
        .then((response) => {
            if (response.body.errors) {
                throw response.body.errors
            }
            return response.body
        })
}

export const deleteItemFromAPI = function (id, blogId) {
    return Vue.http.delete('delete_item.php?articule_id=' + id + '&blog_id=' + blogId)
        .then((response) => {
            if (response.body.errors) {
                throw response.body.errors
            }
            return response.body
        })
}

export const changeStatus = function (id) {
    var formData = new FormData()
    formData.append('blog_id', id)
    return Vue.http.post('change_status.php', formData)
        .then((response) => {
            //  errors
            if (response.body.errors) {
                return response.body
            }

            return response.body
        })
}

export default {
    getItems: getArticules,
    Login: Login,
    createArticulo: createArticulo,
    getArticulesList: getArticulesList,
    deleteArticulo: deleteArticulo,
    deleteItemFromAPI: deleteItemFromAPI,
    updateBlog: updateBlog,
    changeStatus: changeStatus,
    getBlogInfo: getBlogInfo
}



// WEBPACK FOOTER //
// ./src/api/index.js